<template>
  <HScaffold :title="title">
    <template #customRight>
      <div @click="useComApi.openService"
           style="display: flex;flex-direction: row;align-items: center;justify-content: center">
        <img :src="iconService" style="height:25px;" alt="">
        <div :style="hcf.getTextStyle({color:'main',marginLeft:3})">客服</div>
      </div>
    </template>
    <HSwiper :data="bannerData" height="93px" style="padding: 0;margin:0;border-radius: 0;"/>
    <div class="lrTabs">
      <div @click="changeType(true)" :class="['lrTab',isPasswdType?'lrTabActive':'']">
        <div :class="['lrTabText',isPasswdType?'lrTabTextActive':'']">{{ tabTexts.value[0] }}</div>
      </div>
      <div @click="changeType(false)" :class="['lrTab',!isPasswdType?'lrTabActive':'']">
        <div :class="['lrTabText',!isPasswdType?'lrTabTextActive':'']">{{ tabTexts.value[1] }}</div>
      </div>
    </div>
    <EachLrContent :valueChangeCallback="valueChangeCallback" :isLogin="isLogin" :isPasswdType="isPasswdType"/>
    <div v-if="!isLogin" :style="[hcf.getTextStyle({color:'#aaa'}),{backgroundColor:'white',paddingLeft:'10px'}]">
      {{ alertText }}
    </div>
    <div v-if="isPasswdType" style="display: flex;flex-direction: row;padding-top: 10px;margin-left:10px;background-color: white;">
      <van-checkbox @change="changeIsSavePwd" icon-size="16px" v-model="isSavePwd" :checked-color="hcf.getMainColor()"/>
      <div :style="hcf.getTextStyle({marginLeft:5,color:'#333'})">保存密码</div>
    </div>
    <div class="lrBottomDiv">
      <div v-if="!isLogin" style="display: flex;flex-direction: row;margin-top: 10px;">
        <van-checkbox @change="changeIsAgree" icon-size="16px" v-model="isAgree" :checked-color="hcf.getMainColor()"/>
        <div :style="hcf.getTextStyle({marginLeft:5,color:'#333'})">已阅读并同意</div>
        <div :style="hcf.getTextStyle({color:'main'})">《用户服务协议》</div>
      </div>
      <HButton :title="title" :callback="goLr" :disabled="!isCanLr"/>
      <div @click="changeLoginRegister" style="display: flex;flex-direction: row;margin-top: 10px;align-items: center;">
        <div :style="hcf.getTextStyle({fontWeight:'bold',marginLeft:5,color:'#333',addSize:1})">
          {{ !isLogin ? "已有账号，" : "暂无账号，" }}
        </div>
        <div :style="hcf.getTextStyle({fontWeight:'bold',color:'main',addSize:1,marginLeft:3})">
          {{ !isLogin ? "去登录" : "去注册" }}
        </div>
        <van-icon name="arrow" :color="hcf.getMainColor()"/>
      </div>
    </div>
  </HScaffold>
</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import EachLrContent from "@/components/pages/LoginRegister/EachLrContent.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {showToast} from "vant";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HSwiper from "@/components/utils/HSwiper.vue";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import {hsp, SaveEnum} from "@/components/utils/HSp.js";
  import {useHComApi} from "@/hooks/useHComApi.js";
  import {hr} from "@/components/utils/HRouter.js";

  let useHttp = useHHttp();
  let useComApi = useHComApi();

  const iconService = hcf.getNewGameUIIcon("service.png");
  const tabTexts = ref([]);
  const title = ref("");
  const isLogin = ref(false);
  const isPasswdType = ref(true);
  const alertText = ref("");
  const isAgree = ref(true);
  const isCanLr = ref(false);
  const isSavePwd = ref(true);

  let bannerData = useComApi.homeBannerList;
  let value1 = "";
  let value2 = "";
  let value3 = "";

  changeLoginRegister();
  getAlertText();
  if(hsp.checkKey(SaveEnum.savePwd)){
    isSavePwd.value = hsp.getBool(SaveEnum.savePwd, true);
  }

  function goLr() {
    if (!isPasswdType.value && value1.length !== 11) {
      showToast("电话号码长度不正确");
    }

    if (!isLogin.value && isPasswdType.value) {
      //先检查账户名是否已经注册
      useHttp.request("/app/reg/username/check",
          (data) => {
            if (data["Registed"]) {
              showToast("此账号已被注册,请更换您的账号");
            } else {
              //先检查账号是否已经被注册过了
              sendLoginRequest();
            }
          }, {
            params: {
              "AppId": hdi.channelFlag,
              "UserName": value1,
            },
          });
    } else {
      //登录
      sendLoginRequest();
    }
  }

  function sendLoginRequest() {
    let reqJson = {};
    let reqPath = "";
    if (!isLogin.value) {
      reqPath = isPasswdType.value ? "/app/reg/username" : "/app/reg/mobile";
    } else {
      reqPath = isPasswdType.value
          ? "/app/login/username-pwd"
          : "/app/login/mobile-sms";
    }

    //活动红包雨的第一次注册，暂时不需要
    let activityFirstRegisterMoney = 0;
    reqJson = isPasswdType.value
        ? {
          "AppId": hdi.channelFlag,
          "UserName": value1,
          "PassWord": value2,
          "Did": hdi.deviceId,
          "RegPlat": hdi.platTypeNo,
          "DeviceInfo": hdi.deviceModal,
          "FromIc": value3,
          "RegBalance": activityFirstRegisterMoney,
        }
        : {
          "AppId": hdi.channelFlag,
          "AreaCode": "+86",
          "Mobile": value1,
          "Captcha": value2,
          "Did": hdi.deviceId,
          "RegPlat": hdi.platTypeNo,
          "DeviceInfo": hdi.deviceModal,
          "FromIc": value3,
          "RegBalance": activityFirstRegisterMoney,
        };
    useHttp.request(reqPath,
        (data) => {
          if (isPasswdType.value) {
              hsp.setString(SaveEnum.userAccount, value1);
              if (isSavePwd.value) {
                hsp.setBool(SaveEnum.savePwd, true);
                hsp.setString(SaveEnum.userPwd, value2);
              } else {
                hsp.setBool(SaveEnum.savePwd, false);
                hsp.remove(SaveEnum.userPwd);
              }
          }
          useComApi.loginSuccess(data);
          useComApi.updateAppConfig();
          hr.goBack();
        }, {
          params: reqJson, errCallBack: (_) => {
          }, forceToastErrorMsg: true
        });
  }

  function valueChangeCallback(tValue1, tValue2, tValue3) {
    value1 = tValue1;
    value2 = tValue2;
    value3 = tValue3;
    isCanGo();
  }

  function changeIsAgree(){
    isCanGo();
  }

  function changeIsSavePwd() {
     hsp.setBool(SaveEnum.savePwd, isSavePwd.value);
     if(!isSavePwd.value){
       hsp.remove(SaveEnum.userPwd);
     }
  }

  function isCanGo() {
    if (value1 !== "" && value2 !== "" && (isLogin.value || (isAgree.value && !isLogin.value))) {
      isCanLr.value = true;
    } else {
      isCanLr.value = false;
    }
  }

  function changeLoginRegister() {
    isLogin.value = !isLogin.value;
    if (isLogin.value) {
      title.value = "登录";
      tabTexts.value = ref(["密码登录", "验证码登录"]);
    } else {
      title.value = "注册";
      tabTexts.value = ref(["账号注册", "手机号注册"]);
    }
    isCanGo();
  }

  function changeType(val) {
    isPasswdType.value = val;
    getAlertText();
  }

  function getAlertText() {
    if (isPasswdType.value) {
      alertText.value = "*防止账号无法找回,注册成功后请及时绑定手机号";
    } else {
      alertText.value = "*未注册的手机号将自动为您注册账号";
    }
  }

</script>
<style scoped>
  .lrBottomDiv {
    padding: 10px;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .lrTabText {
    color: #aaa;
    font-weight: bold;
  }

  .lrTabTextActive {
    color: var(--ct-main-color);
  }

  .lrTab {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
    color: grey;
  }

  .lrTabActive {
    background-color: white;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
  }

  .lrTabs {
    display: flex;
    flex-direction: row;
    background-color: var(--ct-main-bg-color);
    height: 50px;
  }
</style>
